import React, { useState } from 'react';
import { CountdownTimer } from './CountdownTimer';
import { CheckIcon, StarIcon } from 'lucide-react';
type PackType = 'basic' | 'intermediate' | 'complete';
const CHECKOUT_URLS: Record<PackType, string> = {
  basic: 'https://checkoutarg.recursodigital.shop/cart/48507761066203:1',
  intermediate: 'https://checkoutarg.recursodigital.shop/cart/48507764572379:1',
  complete: 'https://checkoutarg.recursodigital.shop/cart/48507766866139:1'
};
export function FinalCTA() {
  const [selectedPack, setSelectedPack] = useState<PackType>('complete');
  return <section className="w-full bg-[#0a0a0a] py-8 md:py-12 px-4 border-t border-gray-800 relative overflow-hidden" data-id="element-61">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-yellow-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-62"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-63">
        <div className="text-center mb-8" data-id="element-64">
          <h2 className="text-2xl md:text-3xl font-black font-heading text-white mb-3" data-id="element-65">
            🧠 MEGAPACK AFRONTAR LA VEJEZ DE TUS PADRES
          </h2>
          <p className="text-base md:text-lg text-gray-400 font-body mb-2 italic" data-id="element-66">
            Puedes seguir evitando decisiones…
          </p>
          <p className="text-lg md:text-xl font-black text-yellow-400 font-heading mb-3" data-id="element-67">
            O puedes tener un sistema claro desde hoy
          </p>
          <div className="inline-block bg-gray-900 border border-gray-800 rounded-full px-4 py-1.5" data-id="element-68">
            <p className="text-sm md:text-base text-white font-heading font-bold" data-id="element-69">
              👉 Acompañar esta etapa con claridad es posible
            </p>
          </div>
        </div>

        <div className="text-center mb-8 bg-gray-900/50 border border-gray-800 rounded-2xl p-5" data-id="element-70">
          <p className="text-yellow-400 font-black text-base mb-3 font-heading tracking-wide" data-id="element-71">
            ⏰ El precio de lanzamiento termina en:
          </p>
          <CountdownTimer data-id="element-72" />
        </div>

        <div className="text-center mb-6" data-id="element-73">
          <h3 className="text-xl md:text-2xl font-black font-heading text-white mb-1.5" data-id="element-74">
            Elige tu <span className="text-yellow-400" data-id="element-75">MegaPack:</span>
          </h3>
          <p className="text-gray-400 font-body text-xs md:text-sm" data-id="element-76">
            Todas las opciones incluyen los 6 bonos
          </p>
        </div>

        <div className="space-y-3 mb-8" data-id="element-77">
          {/* Pack Básico */}
          <div onClick={() => setSelectedPack('basic')} className={`cursor-pointer rounded-xl p-4 md:p-5 border-2 transition-all duration-300 flex items-center gap-3 ${selectedPack === 'basic' ? 'bg-gray-800 border-yellow-400 shadow-[0_0_20px_rgba(250,204,21,0.15)]' : 'bg-gray-900 border-gray-800 hover:border-gray-700'}`} data-id="element-78">
            <div className="flex-shrink-0" data-id="element-79">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${selectedPack === 'basic' ? 'border-yellow-400' : 'border-gray-600'}`} data-id="element-80">
                {selectedPack === 'basic' && <div className="w-2.5 h-2.5 rounded-full bg-yellow-400" data-id="element-81" />}
              </div>
            </div>
            <div className="flex-1 flex flex-col md:flex-row md:items-center justify-between gap-2" data-id="element-82">
              <div data-id="element-83">
                <div className="flex items-center gap-2 mb-0.5" data-id="element-84">
                  <span className="text-lg" data-id="element-85">📘</span>
                  <h4 className="text-base md:text-lg font-black font-heading text-white" data-id="element-86">
                    PACK BÁSICO
                  </h4>
                </div>
                <p className="text-xs text-gray-400 font-body" data-id="element-87">
                  6 tomos + 6 bonos
                </p>
              </div>
              <div className="text-left md:text-right" data-id="element-88">
                <p className="text-[10px] text-gray-500 line-through font-body" data-id="element-89">
                  ARS 27.990
                </p>
                <p className="text-xl font-black font-heading text-white" data-id="element-90">
                  ARS 19.990
                </p>
              </div>
            </div>
          </div>

          {/* Pack Completo (MÁS ELEGIDO - en el medio) */}
          <div onClick={() => setSelectedPack('complete')} className={`cursor-pointer rounded-xl p-4 md:p-5 border-2 transition-all duration-300 flex items-start md:items-center gap-3 ${selectedPack === 'complete' ? 'bg-gray-800 border-yellow-400 shadow-[0_0_30px_rgba(250,204,21,0.25)] scale-[1.02] z-10 relative' : 'bg-gray-900 border-gray-800 hover:border-gray-700'}`} data-id="element-91">
            <div className="flex-shrink-0 mt-1 md:mt-0" data-id="element-92">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${selectedPack === 'complete' ? 'border-yellow-400' : 'border-gray-600'}`} data-id="element-93">
                {selectedPack === 'complete' && <div className="w-2.5 h-2.5 rounded-full bg-yellow-400" data-id="element-94" />}
              </div>
            </div>
            <div className="flex-1 flex flex-col md:flex-row md:items-center justify-between gap-3" data-id="element-95">
              <div data-id="element-96">
                <div className="flex items-center gap-2 mb-1.5" data-id="element-97">
                  <span className="text-lg" data-id="element-98">🏆</span>
                  <h4 className="text-base md:text-lg font-black font-heading text-white" data-id="element-99">
                    PACK COMPLETO
                  </h4>
                </div>
                <div className="flex flex-wrap gap-1.5 mb-2" data-id="element-100">
                  <span className="bg-yellow-400 text-black text-[9px] font-black px-2 py-0.5 rounded flex items-center gap-1 font-heading tracking-wide" data-id="element-101">
                    <StarIcon className="w-2.5 h-2.5 fill-black" data-id="element-102" /> MÁS ELEGIDO
                  </span>
                </div>
                <p className="text-xs text-gray-400 font-body mb-1.5 font-medium" data-id="element-103">
                  TODO lo anterior +
                </p>
                <ul className="space-y-1" data-id="element-104">
                  <li className="text-xs text-gray-300 font-body flex items-center gap-1.5" data-id="element-105">
                    <CheckIcon className="w-3.5 h-3.5 text-green-500 flex-shrink-0" data-id="element-106" />
                    Sistema de Personalización PRO
                  </li>
                  <li className="text-xs text-gray-300 font-body flex items-center gap-1.5" data-id="element-107">
                    <CheckIcon className="w-3.5 h-3.5 text-green-500 flex-shrink-0" data-id="element-108" />
                    Sistema de Casos Difíciles
                  </li>
                  <li className="text-xs text-gray-300 font-body flex items-center gap-1.5" data-id="element-109">
                    <CheckIcon className="w-3.5 h-3.5 text-green-500 flex-shrink-0" data-id="element-110" />
                    Sistema de Implementación Real
                  </li>
                </ul>
              </div>
              <div className="text-left md:text-right mt-2 md:mt-0" data-id="element-111">
                <p className="text-[10px] text-gray-500 line-through font-body" data-id="element-112">
                  ARS 79.990
                </p>
                <p className="text-2xl md:text-3xl font-black font-heading text-yellow-400" data-id="element-113">
                  ARS 27.990
                </p>
              </div>
            </div>
          </div>

          {/* Pack Intermedio */}
          <div onClick={() => setSelectedPack('intermediate')} className={`cursor-pointer rounded-xl p-4 md:p-5 border-2 transition-all duration-300 flex items-center gap-3 ${selectedPack === 'intermediate' ? 'bg-gray-800 border-yellow-400 shadow-[0_0_20px_rgba(250,204,21,0.15)]' : 'bg-gray-900 border-gray-800 hover:border-gray-700'}`} data-id="element-114">
            <div className="flex-shrink-0" data-id="element-115">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${selectedPack === 'intermediate' ? 'border-yellow-400' : 'border-gray-600'}`} data-id="element-116">
                {selectedPack === 'intermediate' && <div className="w-2.5 h-2.5 rounded-full bg-yellow-400" data-id="element-117" />}
              </div>
            </div>
            <div className="flex-1 flex flex-col md:flex-row md:items-center justify-between gap-2" data-id="element-118">
              <div data-id="element-119">
                <div className="flex items-center gap-2 mb-0.5" data-id="element-120">
                  <span className="text-lg" data-id="element-121">📗</span>
                  <h4 className="text-base md:text-lg font-black font-heading text-white" data-id="element-122">
                    PACK INTERMEDIO
                  </h4>
                </div>
                <p className="text-xs text-gray-400 font-body" data-id="element-123">
                  Pack Básico + Manual Completo de Comunicación
                </p>
              </div>
              <div className="text-left md:text-right" data-id="element-124">
                <p className="text-[10px] text-gray-500 line-through font-body" data-id="element-125">
                  ARS 49.990
                </p>
                <p className="text-xl font-black font-heading text-white" data-id="element-126">
                  ARS 23.990
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Button */}
        <div className="mt-6" data-id="element-127">
          <a href={CHECKOUT_URLS[selectedPack]} className="block w-full bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-black text-lg md:text-xl py-4 rounded-xl text-center transition-all duration-300 cursor-pointer font-heading shadow-[0_0_20px_rgba(250,204,21,0.3)] hover:shadow-[0_0_30px_rgba(250,204,21,0.4)] hover:scale-[1.01]" data-id="element-128">
            👉 QUIERO MI MEGAPACK AHORA
          </a>
          <div className="flex flex-wrap justify-center gap-3 md:gap-5 mt-4 text-[10px] md:text-xs text-gray-400 font-body font-medium" data-id="element-129">
            <span className="flex items-center gap-1" data-id="element-130">🔒 Pago seguro</span>
            <span className="flex items-center gap-1" data-id="element-131">⚡ Acceso inmediato</span>
            <span className="flex items-center gap-1" data-id="element-132">🛡️ Garantía 7 días</span>
          </div>
        </div>
      </div>
    </section>;
}